import React from 'react';
import { L } from '../../styles/theme';
import { BRAND_MARK_PATHS, BRAND_MARK_VIEWBOX } from '../../components/layout/brandMark';

export const authLabelStyle: React.CSSProperties = {
  fontSize: 12,
  color: L.muted,
  display: 'block',
  marginBottom: 5,
};

/** Общая рамка страниц входа: логотип, карточка, сноска. */
const AuthShell: React.FC<{ children: React.ReactNode; footer?: React.ReactNode }> = ({
  children,
  footer,
}) => (
  <div
    style={{
      minHeight: '100dvh',
      background: L.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}
  >
    <div style={{ width: '100%', maxWidth: 340 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 22 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            background: L.accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg viewBox={BRAND_MARK_VIEWBOX} width={14} height={18} fill="#fff" aria-label="Ақсайым">
            {BRAND_MARK_PATHS.map((d) => (
              <path key={d.slice(0, 16)} d={d} fillRule="evenodd" />
            ))}
          </svg>
        </div>
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: L.ink,
              letterSpacing: '-0.01em',
              lineHeight: 1.2,
            }}
          >
            Ақсайым
          </div>
          <div style={{ fontSize: 11, color: L.muted }}>панель управления</div>
        </div>
      </div>

      <div
        style={{
          border: `1px solid ${L.line}`,
          borderRadius: 10,
          background: L.surface,
          boxShadow: L.shadow,
          padding: '18px 18px 16px',
        }}
      >
        {children}
      </div>

      {footer && (
        <div style={{ fontSize: 11, color: L.faint, marginTop: 14, lineHeight: 1.5 }}>{footer}</div>
      )}
    </div>
  </div>
);

export default AuthShell;
